import React, { useState, useEffect } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { eachDayOfInterval } from 'date-fns';
import { formatDateToString } from '../../../helper/date';

export const CampaignUtmBarChart = ({
  allInquiries,
  filteredInquiries,
  adParameter,
  selectionRange,
  loading,
  selectedCompany,
}) => {
  const [series, setSeries] = useState([]);
  const [xAxisData, setXAxisData] = useState([]);

  useEffect(() => {
    setXAxisData(
      eachDayOfInterval({
        start: selectionRange.startDate,
        end: selectionRange.endDate,
      })
    );
  }, [selectionRange]);

  useEffect(() => {
    if (
      !loading &&
      allInquiries.data &&
      filteredInquiries.data &&
      xAxisData.length
    ) {
      let seriesData = {};
      let possibleValues = [];

      for (const item of filteredInquiries.data) {
        const adCookie = JSON.parse(item.adCookie);
        const params = new URLSearchParams(adCookie.url.split('?')[1]);
        const param = params.get(adParameter);

        if (possibleValues.indexOf(param) === -1) {
          possibleValues.push(param);
        }
      }

      const res = possibleValues.reduce(
        (acc, curr) => ((acc[curr] = 0), acc),
        {}
      );

      for (const date of xAxisData) {
        seriesData[formatDateToString(date)] = { ...{ all: 0 }, ...res };
      }

      if (allInquiries.data) {
        allInquiries.data.forEach((item) => {
          const itemDate = new Date(item.createdAt);
          seriesData[formatDateToString(itemDate)].all++;
        });
      }

      filteredInquiries.data.forEach((item, index) => {
        const itemDate = new Date(item.createdAt);
        const adCookie = JSON.parse(item.adCookie);
        const params = new URLSearchParams(adCookie.url.split('?')[1]);
        const param = params.get(adParameter);

        if (
          typeof seriesData[formatDateToString(itemDate)][param] === 'number'
        ) {
          seriesData[formatDateToString(itemDate)][param]++;
        }
      });

      const seriesDataArray = Object.entries(seriesData);

      let seriesDataAll = {};
      seriesDataAll['all'] = [];
      for (const sd of seriesDataArray) {
        seriesDataAll['all'].push(sd[1].all);
      }

      for (const pv of possibleValues) {
        seriesDataAll[pv] = [];

        for (const sda of seriesDataArray) {
          seriesDataAll[pv].push(sda[1][pv]);
        }
      }

      let seriesArray = [];
      for (const [key, value] of Object.entries(seriesDataAll)) {
        seriesArray.push({ data: value, label: key });
      }

      setSeries(seriesArray);
    }
  }, [xAxisData, loading, adParameter, selectedCompany]);

  return (
    <BarChart
      xAxis={[{ scaleType: 'band', data: xAxisData }]}
      series={series}
      loading={loading}
      // margin={{ top: 10, bottom: 50 }}
      slotProps={{
        legend: {
          hidden: true,
        },
      }}
      // width={800}
      height={400}
    />
  );
};
